package ai.flowstorm.studio.ui.design.dialogue.panel

import ai.flowstorm.studio.App
import ai.flowstorm.common.BotLogic
import io.kvision.snabbdom.VNode
import io.kvision.core.*
import io.kvision.i18n.tr
import io.kvision.panel.SimplePanel
import io.kvision.utils.vh

object AssistantPanel : SimplePanel(className = "wallpaper") {

    val assistantPanel = ChatPanel("assistantDiv", App.config.assistantKey)
    val dialoguePanel = ChatPanel("botDiv", "")
    var route = ""
    var panel: SimplePanel = SimplePanel().apply {
        dialoguePanel.setControls(false)
        height = 100.vh
        add(dialoguePanel)
    }

    init {
        add(panel)
    }
}
